import Http from "../Http";
import { LARAVEL_BACKEND_API_URL } from "../Helper";



// Grammar Check API
export function checkGrammar(textContent) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
        const payload = {
            text: textContent 
        };
        
        Http.post(LARAVEL_BACKEND_API_URL + `v1/ai-grammar-check`, payload)
        .then((res) => {
            return resolve(res);
        })
        .catch((err) => {
            return reject(err);
        });
    });
}
